<template>
	<v-container grid-list-md class="container--box">
		<v-layout row wrap>
			<v-flex xs12 sm3 md3>
				<app-profile-menu
					:customer="$page.props.auth.customer.display_name"
					:customer_image="$page.props.auth.customer_image"
				></app-profile-menu>
			</v-flex>
			<v-flex xs12 sm9 md9>
				<v-card flat>
					<v-card-title primary-title>
						Code #{{ item.code }}
					</v-card-title>
					<v-card-text>
						<v-layout row wrap>
							<v-flex xs12>
								<v-card flat>
									<v-card-text>
										<v-layout row wrap>
											<v-flex xs12 md6>
												<v-card
													class="
														flex
														d-flex
														flex-column
													"
													ripple
												>
													<v-img
														height="250"
														:src="outlet.image_url"
													></v-img>
													<v-card-title primary-title>
														{{ outlet.name }}
													</v-card-title>
													<v-card-text
														class="fill-height"
													>
														<v-row
															align="center"
															class="mx-0 mb-2"
														>
															<v-rating
																:value="4.5"
																color="amber"
																dense
																half-increments
																readonly
																size="14"
															></v-rating>

															<div
																class="
																	grey--text
																	ms-4
																"
															>
																4.5 (413)
															</div>
														</v-row>

														<div
															v-html="
																outlet.description
															"
															v-line-clamp:20="3"
														></div>
													</v-card-text>
												</v-card>
											</v-flex>
											<v-flex xs12 md6>
												<v-list>
													<v-list-item>
														<v-list-item-content>
															<v-list-item-subtitle
																>{{
																	$t(
																		"label.adults"
																	)
																}}</v-list-item-subtitle
															>
															<v-list-item-title
																class="
																	font-weight-bold
																"
																>{{
																	item.adults
																}}</v-list-item-title
															>
														</v-list-item-content>
													</v-list-item>
													<v-list-item>
														<v-list-item-content>
															<v-list-item-subtitle
																>{{
																	$t(
																		"label.children"
																	)
																}}</v-list-item-subtitle
															>
															<v-list-item-title
																class="
																	font-weight-bold
																"
																>{{
																	item.children
																}}</v-list-item-title
															>
														</v-list-item-content>
													</v-list-item>
													<v-list-item>
														<v-list-item-content>
															<v-list-item-subtitle
																>{{
																	$t(
																		"label.date"
																	)
																}}</v-list-item-subtitle
															>
															<v-list-item-title
																class="
																	font-weight-bold
																"
															>
																{{
																	item.date
																}}</v-list-item-title
															>
														</v-list-item-content>
													</v-list-item>
													<v-list-item>
														<v-list-item-content>
															<v-list-item-subtitle
																>{{
																	$t(
																		"label.time"
																	)
																}}</v-list-item-subtitle
															>
															<v-list-item-title
																class="
																	font-weight-bold
																"
																>{{
																	item.time
																}}</v-list-item-title
															>
														</v-list-item-content>
													</v-list-item>
													<v-list-item>
														<v-list-item-content>
															<v-list-item-subtitle
																>{{
																	$t(
																		"Description"
																	)
																}}</v-list-item-subtitle
															>
															<v-list-item-title
																class="
																	font-weight-bold
																"
																>{{
																	item.description
																}}</v-list-item-title
															>
														</v-list-item-content>
													</v-list-item>
												</v-list>
											</v-flex>
										</v-layout>
									</v-card-text>
								</v-card>
							</v-flex>
						</v-layout>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import ReservationStepper from "@Reservation/components/ReservationStepper.vue";
export default {
	components: {
		ReservationStepper,
	},
	props: ["reservation", "outlet"],
	data() {
		return {
			item: this.reservation,
		};
	},
};
</script>